import "./upgrade-button-addons.scss"
import { BUTTON_VARIANTS } from "../../../../components/inputs/button-variants";
import { Button } from "../../../../components/inputs/button/button";


interface IUpgradeButtonAddons {
    disabled: boolean;
    onClick?: () => void;
    buttonCaption: string;
}

const UpgradeButtonAddons: React.FC<IUpgradeButtonAddons> = ({disabled = false, onClick, buttonCaption}) => {
    return (
        <div className="upgrade-button-addons">
            <Button disabled={disabled} variant={BUTTON_VARIANTS.Secondary} onClick={onClick} text={buttonCaption} />
        </div>
    )
}

export default UpgradeButtonAddons;
